import { add, listen, qs, qsa, remove } from '@fluorescent/dom';

export default function Media(node) {
  const { Shopify, YT } = window;
  const elements = qsa('[data-interactive]', node);

  if (!elements.length) return;

  const acceptedTypes = ['video', 'model', 'external_video'];
  let activeMedia = null;
  let instances = {};

  elements.forEach(initElement);

  function initElement(el) {
    const { mediaId, mediaType } = el.dataset;
    if (!mediaType || !acceptedTypes.includes(mediaType)) return;

    if (Object.keys(instances).includes(mediaId)) return;

    let instance = {
      id: mediaId,
      type: mediaType,
      container: el,
      media: el.children[0],
    };

    switch (instance.type) {
      case 'video':
        let shopifyPlyrCSS = document.createElement("link");
        shopifyPlyrCSS.type = "text/css";
        shopifyPlyrCSS.rel = "stylesheet";
        shopifyPlyrCSS.href = "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css";
        document.getElementsByTagName("head")[0].appendChild(shopifyPlyrCSS);

        window.Shopify.loadFeatures(
          [
            {
              name: 'video-ui',
              version: '1.0',
            },
          ],
          () => {
            console.log("shopify video-ui loaded")
            instance.player = new Shopify.Plyr(instance.media, {
              loop: { active: el.dataset.loop == 'true' },
            });
          }
        );
        break;

      case 'external_video':
        window.onYouTubeIframeAPIReady = function () {
          if (YT) {
            instance.player = new YT.Player(instance.media);
          }
        };

        var youtubeIframeAPIScript = document.createElement('script');
        youtubeIframeAPIScript.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(youtubeIframeAPIScript, firstScriptTag);
        break;

      case 'model':
        window.Shopify.loadFeatures(
          [
            {
              name: 'model-viewer-ui',
              version: '1.0',
            },
            {
              name: 'shopify-xr',
              version: '1.0',
            }
          ],
          () => {
            instance.viewer = new Shopify.ModelViewerUI(qs('model-viewer', el));
            listen(qs('.model-poster', el), 'click', e => {
              e.preventDefault();
              playModel(instance);
            });
          }
        );

        break;
    }

    instances[mediaId] = instance;

    if (instance.player) {
      if (instance.type === 'video') {
        instance.player.on('playing', () => {
          pauseActiveMedia(instance);
          activeMedia = instance;
        });
      } else if (instance.type === 'external_video') {
        instance.player.addEventListener('onStateChange', event => {
          if (event.data === 1) {
            pauseActiveMedia(instance);
            activeMedia = instance;
          }
        });
      }
    }
  }

  function playModel(instance) {
    pauseActiveMedia(instance);
    instance.viewer.play();
    add(instance.container, 'model-active');
    activeMedia = instance;

    setTimeout(() => {
      qs('model-viewer', instance.container).focus();
    }, 300);
  }

  function pauseActiveMedia(instance) {
    if (!activeMedia || instance == activeMedia) return;

    if (activeMedia.player) {
      if (activeMedia.type === 'video') {
        activeMedia.player.pause();
      } else if (activeMedia.type === 'external_video') {
        activeMedia.player.pauseVideo();
      }

      activeMedia = null;
      return;
    }

    if (activeMedia.viewer) {
      remove(activeMedia.container, 'model-active');
      activeMedia.viewer.pause();
      activeMedia = null;
    }
  }

  return { pauseActiveMedia };
}
